const ExerciesFiles = () => {
  return <h2>ExerciesFiles</h2>;
};
export default ExerciesFiles;
